import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BubbleHintArrowPosition } from '@pso-ui/bubble-hint/bubble-hint.component.model';

@Component({
  selector: 'app-bubble-hint',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './bubble-hint.component.html',
  styleUrls: ['./bubble-hint.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BubbleHintComponent {
  @HostBinding('class')
  @Input()
  arrowPosition: BubbleHintArrowPosition = BubbleHintArrowPosition.UP;
}
